import styled from 'styled-components'
import { MdInventory2 } from 'react-icons/md'
import useApi from '../../../hooks/useApi'
import { useQuery } from '@tanstack/react-query'

const ImgWrap = styled.div`
    width: ${({ $size }) => $size === 'sm' ? '60px' : $size === 'lg' ? '140px' : '100px'};
    height: ${({ $size }) => $size === 'sm' ? '60px' : $size === 'lg' ? '140px' : '100px'};
    border-radius: 0.375rem;
    overflow: hidden;
    border: 1px solid ${({ theme }) => theme.form.border};
    background: ${({ theme }) => theme.form.background};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`

const Img = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`

const Placeholder = styled.div`
    color: ${({ theme }) => theme.font.label};
    font-size: ${({ $size }) => $size === 'sm' ? '1.4rem' : '2rem'};
    display: flex;
    align-items: center;
    justify-content: center;
`

const ProductImage = ({ itemId, size = 'md' }) => {
    const { getMe } = useApi()

    const { data } = useQuery({
        queryKey: ['product', itemId],
        queryFn: () => getMe(`product/${itemId}`),
        enabled: !!itemId,
        staleTime: 5 * 60 * 1000,
    })

    const imageUrl = data?.data?.imageUrl || data?.data?.image || null

    return (
        <ImgWrap $size={size}>
            {imageUrl
                ? <Img src={imageUrl} alt="" />
                : <Placeholder $size={size}><MdInventory2 /></Placeholder>
            }
        </ImgWrap>
    )
}

export default ProductImage
